function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import classnames from 'classnames';
var uniqueId = 0;

/**
 * Status: *finished*
 * Category: FormElements
 **/
var Tooltip = function Tooltip(_ref) {
  var buttonContent = _ref.buttonContent,
    children = _ref.children,
    className = _ref.className,
    isExpanded = _ref.isExpanded,
    label = _ref.label,
    text = _ref.text,
    isPositionAbsolute = _ref.isPositionAbsolute;
  var _useState = useState(isExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(uniqueId++),
    _useState4 = _slicedToArray(_useState3, 1),
    id = _useState4[0];
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('tooltip', {
      'tooltip--show': expanded
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltip__button-container"
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: "tooltip__button-".concat(id)
  }, label), /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: "tooltip__button-".concat(id),
    className: "tooltip__button",
    "aria-controls": "tooltip__box-".concat(id),
    "aria-expanded": expanded,
    onClick: function onClick(e) {
      setExpanded(!expanded);
      e.stopPropagation();
    },
    onMouseOver: function onMouseOver() {
      return setExpanded(true);
    },
    onMouseOut: function onMouseOut() {
      return setExpanded(false);
    }
  }, buttonContent || 'i')), /*#__PURE__*/React.createElement("div", {
    className: classnames('tooltip__box', {
      'tooltip__box--absolute': isPositionAbsolute
    }),
    id: "tooltip__box-".concat(id)
  }, children || text));
};
Tooltip.propTypes = {
  /** Content of the tooltip button; defaults to "i". */
  buttonContent: PropTypes.node,
  /** The content of the tooltip (if a plain string is not enough). Provide either `text` or `children`. */
  children: PropTypes.node,
  className: PropTypes.string,
  isExpanded: PropTypes.bool,
  /** If provided, add a label to the tooltip button. */
  label: PropTypes.string,
  /** The content of the tooltip as a plain string. Provide either `text` or `children`. */
  text: PropTypes.string
};
export default Tooltip;